import { FC, useEffect, useRef, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { booking } from 'services/transfer';
import { TransferBookingResponse } from 'ts/transfer/interfaces/TransferResultsResponse';
import TransferBooking from './Booking';
import SkeletonTransferBook from './TransferBookSkeleton';
import { saveScreenshot } from 'utils/utils';
import usePageInMemory from 'hooks/usePageInMemory';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { useGetPage } from 'hooks/useGetPage';
import { b2b } from 'constants/generic';

const BookTransferPage: FC = () => {
  const [urlParams] = useSearchParams();
  const [response, setResponse] = useState<TransferBookingResponse>();
  const bookRef = useRef<HTMLDivElement>(null);
  const location = useLocation();

  const idbKey = location.pathname + location.search;
  const { onClickBack, onClickSearch } = usePageInMemory(idbKey, () => { });

  useGetPage('Transfers/Book');

  useEffect(() => {
    if (b2b) {
      if (location.pathname !== `/transfer/book`) {
        return;
      }

      const latestSearch = sessionStorage.getItem('latestTransferPath');
      if (latestSearch) {
        const latest = JSON.parse(latestSearch);

        const latestSearchObj = new URLSearchParams(latest.search);
        const locationSearchObj = new URLSearchParams(location.search);

        if (latestSearchObj.toString() === locationSearchObj.toString()) {
          return;
        }
      }
    }
    (async () => {
      const paramsObj = Object.fromEntries(urlParams.entries());
      const params = {
        searchToken: paramsObj.searchToken,
        ukeyForward: paramsObj.ukeyForward,
        ukeyReturn: paramsObj.ukeyReturn,
      };

      const newResponse = await booking(params);

      setResponse(newResponse);
    })();
  }, [urlParams.get('searchToken'), urlParams.get('ukeyForward'), urlParams.get('ukeyReturn')]); // eslint-disable-line

  return (
      <div className="results-main transfer-search-wr" ref={bookRef}>
        {!!response?.bookingModel?.forward && (
          <TransferBooking
            bookingModel={response?.bookingModel}
            saveScreenshot={async (name) => await saveScreenshot(bookRef.current, name, 'Transfer')}
            onUpdate={(model) => setResponse({ ...response, bookingModel: model })}
            onClickBack={() => onClickBack('transfer', 'result')}
            onClickSearch={() => onClickSearch('transfer', '/transfers')}
          />
        )}
        {!response && <SkeletonTransferBook />}
      </div>
  );
};

export default withErrorBoundary(BookTransferPage, 'BookTransferPage');
